import React from 'react'
import Loading from '../../../images/icons/loading.svg'

const LoadingIcon = ({ size }) => (
  <Loading style={{ width: size === 'sm' ? 24 : 48, height: size === 'sm' ? 24 : 48 }} className="animation-rotate" />
)

export default LoadingIcon